export const solutionsHero = {
  eyebrow: '解决方案',
  title: '从客户场景出发的整体解决方案',
  titleHighlight: '不只展示单项产品',
  subtitle: '围绕客户业务目标，组合产品、技术与实施能力，提供可落地的整体解决方案。',
  desc: '覆盖县域数字商业、乡村数字经济、县域商业网络、供应链协同、数字消费、AI 应用与数据治理等方向。',
};

export interface SolutionDirection {
  id: string;
  icon: string;
  title: string;
  scene: string;
  pain: string;
  products: string[];
  outcome: string;
}

export const solutionDirections: SolutionDirection[] = [
  {
    id: 'SOL-001',
    icon: 'ri-store-2-line',
    title: '县域数字商业解决方案',
    scene: '县域政府、商业主体推动县域商业数字化升级。',
    pain: '县域商业数字化程度低、数据割裂、缺乏统一经营入口。',
    products: ['数字货架', '云铺系统', '数据看板'],
    outcome: '打通县域商业数字化经营与数据回流，形成可运营的数字商业网络。',
  },
  {
    id: 'SOL-002',
    icon: 'ri-community-line',
    title: '乡村数字经济建设方案',
    scene: '乡村振兴与数字乡村战略落地，推动乡村产业数字化。',
    pain: '农产品上行难、信息不对称、乡村小店缺流量与资金。',
    products: ['ePin 溯源', '数字货架', '信用进货'],
    outcome: '打通农产品数字化上行与乡村商业数字化，助力乡村产业振兴。',
  },
  {
    id: 'SOL-003',
    icon: 'ri-git-branch-line',
    title: '县域商业网络建设方案',
    scene: '县乡村三级商业体系建设，构建县域商业网络。',
    pain: '县乡村商业节点分散、协同不足、缺乏统一的数字化连接。',
    products: ['云铺', '云店', '云社员', '数字商业节点'],
    outcome: '构建县乡村三级联动的数字商业节点网络，实现规模化协同。',
  },
  {
    id: 'SOL-004',
    icon: 'ri-truck-line',
    title: '供应链与服务协同方案',
    scene: '供应链企业、门店与消费者的协同效率提升。',
    pain: '供应链数字化程度低、多方协同结算复杂。',
    products: ['供应链数字化', '智能清分', 'ePin 溯源'],
    outcome: '打通供应链与服务经济协同，实现多方高效结算与溯源。',
  },
  {
    id: 'SOL-005',
    icon: 'ri-red-packet-line',
    title: '数字消费与权益运营方案',
    scene: '餐饮、零售等消费场景的数字化权益运营。',
    pain: '消费复购难、传播难，缺乏可核销的数字权益体系。',
    products: ['数字消费', '权益系统', '云厨菜单'],
    outcome: '构建可核销、可复购的数字消费权益场景，驱动用户活跃。',
  },
  {
    id: 'SOL-006',
    icon: 'ri-robot-2-line',
    title: 'AI 应用与智能运营方案',
    scene: '县域与乡村场景的 AI 应用交付与智能运营。',
    pain: '县域商户缺少 AI 能力与数字经营入口，服务依赖人工。',
    products: ['TOMA 智能体', '数字货架', '智能运营'],
    outcome: '以 TOMA 智能体为入口，提供 AI 交互、数字服务与智能运营能力。',
  },
  {
    id: 'SOL-007',
    icon: 'ri-database-2-line',
    title: '数据治理与清分结算方案',
    scene: '多方协同场景下的数据治理与自动结算。',
    pain: '多方结算复杂、数据无法沉淀为可运营资产。',
    products: ['智能清分', '数据看板', '一笔交易一条数据链'],
    outcome: '实现多方协同自动结算与数据资产沉淀，让价值流转透明可查。',
  },
];

export interface RoleModel {
  code: string;
  title: string;
  desc: string;
}

export const edabcRoles: RoleModel[] = [
  { code: 'E', title: '政府及县域管理方', desc: '统筹县域商业体系建设与政策落地，推动数字商业基础设施建设。' },
  { code: 'D', title: '产业投资方', desc: '提供资金与产业资源，参与县域数字商业与乡村数字经济建设。' },
  { code: 'A', title: '区域运营方', desc: '承担区域数字商业网络的运营、培训与商户服务。' },
  { code: 'B', title: '商户与门店', desc: '通过数字货架、云铺与信用进货实现数字化经营。' },
  { code: 'C', title: '消费者及用户', desc: '通过数字消费、权益与云社员协同获得数字化消费体验。' },
];

export const solutionShowcases = [
  { title: '0# 首发', desc: '作为解决方案中的示范验证场景，跑通城市端商业闭环。', href: '/launch' },
  { title: '千县万村', desc: '作为区域复制与规模化解决方案，驱动县域网络扩张。', href: '/scale' },
];

export interface SolutionListing {
  id: string;
  icon: string;
  title: string;
  en: string;
  desc: string;
  href: string;
}

// 解决方案列表页的入口卡片
export const solutionListings: SolutionListing[] = [
  {
    id: 'listing-agriculture',
    icon: 'ri-plant-line',
    title: '智慧农业',
    en: 'Smart Agriculture',
    desc: '以物联网感知与数字身份，打通精准种植、农田数字化与农产品可信溯源，让农业生产可感、可算、可查。',
    href: '/solutions/smart-agriculture',
  },
  {
    id: 'listing-parking',
    icon: 'ri-parking-box-line',
    title: '自由流停车',
    en: 'Free-Flow Parking',
    desc: '以融合识别与无感结算，实现不停车、不减速、不排队的高速、城市道路、路内泊位与停车场全场景一张网。',
    href: '/solutions/smart-parking',
  },
  {
    id: 'listing-catering',
    icon: 'ri-restaurant-line',
    title: '智慧餐饮',
    en: 'Smart Catering',
    desc: '面向门店经营与后厨协同，打通点餐、会员、供应链与数字消费权益，让餐饮经营更高效、复购更简单。',
    href: '/solutions/smart-catering',
  },
  {
    id: 'listing-logistics',
    icon: 'ri-truck-line',
    title: '智慧物流',
    en: 'Smart Logistics',
    desc: '以智能视觉、商用显示与智慧物联为硬件底座，叠加 ePin 一物一码与九畴云市供应链平台，为仓储、运输、园区与末端构建端到端可感知、可调度、可追溯的数智化物流体系。',
    href: '/solutions/smart-logistics',
  },
];